import React, {useContext, useEffect} from "react";
import {CapabilityContext} from "../global/context/CapabilityContext";
import {ASSOCIATE_TAB_METRIC_KEY} from "../util/MetricUtil";
import AssociatePerformanceV2 from "./AssociatePerformanceV2";
import {getDocumentURL, getNodeCapability} from "../handler/ParentDataHandler";
import {getBaseUrl, parseCapabilitiesResponse} from "../util/Util";

const AssociateViewV2 = (props) => {
    const {configViewModel, configDispatch} = useContext(CapabilityContext)

    useEffect(() => {
        Promise.all([getDocumentURL(), getNodeCapability()]).then(result => {
            const model = {
                capability: parseCapabilitiesResponse(result[1]),
                baseUrl: getBaseUrl(result[0])
            }
            configDispatch({type: 'GET_CAPABILITIES', data: model});
            configDispatch({
                type: 'GET_STATION_CONFIG',
                data: {
                    dispatcher: configDispatch,
                    baseUrl: model.baseUrl,
                    metricKey: ASSOCIATE_TAB_METRIC_KEY
                }
            });
        })
    }, []);

    function renderAssociateView() {
        return  <AssociatePerformanceV2 {...props} />
    }

    return (
        <div>
            {configViewModel.capability !== '' && configViewModel.stationConfig.initialised ?
                renderAssociateView() : null
            }
        </div>
    )
}

export default AssociateViewV2


// WEBPACK FOOTER //
// ./src/components/outboundassociate/AssociateViewV2.js